import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import { useNavigate, Link, Navigate, useParams } from "react-router-dom";
import * as signalR from "@microsoft/signalr";

import Preloading from "../../../components/basics/Preloading";

// assets
import DeliveryHeader from "../../../components/header/DeliveryHeader";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DeliveryPanel from "./DeliveryPanel";

const DeliveryOrderList = () => {
  const { branchId } = useParams();
  // const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(null);
  const [filterModel, setFilterModel] = useState({
    invoiceNumber: "",
    merchantPhone: "",
    merchantName: "",
    merchantCode: "",
    orderNumber: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    endDate: "",
    part: 1,
    size: 10,
    total: 0,
    parts: 0,
  });

  const [posDevices, setPosDevices] = useState([]);
  const [paymentWaiting, setpaymentWaiting] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState({
    id: 0,
    totalFinalPrice: 0,
  });
  const [orderTypes, setOrderTypes] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [paymentModel, setPaymentModel] = useState({
    paymentType: 0,
    posDeviceId: 0,
    invoiceId: selectedInvoice.id,
    extraAmount: 0,
    amount: 0,
    cashAmount: 0,
    posAmount: 0,
    cardNumber: "",
    delivered: true,
    isFreePosPayment: false
  });

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const isUserLogedin = methods.checkUserLogin();

  const getGridData = async () => {
    const resp = await apiMethod.getDeliveryUserOrders(
      filterModel.invoiceNumber,
      filterModel.orderNumber,
      filterModel.merchantPhone,
      filterModel.merchantName,
      filterModel.merchantCode,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.part,
      filterModel.size
    );

    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setGridData(resp.data);
    }

    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);
  };

  const getPosData = async () => {
    const posResp = await apiMethod.getUserPosDevices();
    if (methods.showApiErrors(posResp)) {
      setPosDevices(posResp.data);
    }
  };

  const handleClose = () => setShow(null);
  const handleShow = (id) => {
    setShow(id);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      createConnection();
      await getPosData();
      await getGridData();
      setLoading(false);
    };
    fetchData();
  }, []);

  const deliveryToMerchant = async (id) => {
    setLoading(true);
    const deliverToMerchantResp = await apiMethod.deliveryOrderToMerchant(id);
    if (methods.showApiErrors(deliverToMerchantResp)) {
      getGridData();
      setLoading(false);
    }
  };

  const paymentTypeChanged = (paymentType) => {
    paymentModel.paymentType = parseInt(paymentType);
    paymentModel.cashAmount = 0;
    paymentModel.posAmount = 0;
    paymentModel.amount = 0;
    paymentModel.extraAmount = 0;
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const extraAmountChanged = (extraAmount) => {
    if (extraAmount === "" || extraAmount === null || extraAmount === undefined)
      extraAmount = "0";
    extraAmount = methods.allReplace(extraAmount, ",", "");
    paymentModel.extraAmount = parseInt(extraAmount);
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const cashAmountChanged = (cash) => {
    if (cash === "" || cash === null || cash === undefined) cash = "0";
    cash = methods.allReplace(cash, ",", "");
    let paymentAmount =
      paymentModel.extraAmount + selectedInvoice.totalFinalPrice / 10;
    if (paymentAmount <= parseInt(cash)) return false;

    paymentModel.cashAmount = parseInt(cash);
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const calcPaymentAmounts = () => {
    let paymentAmount =
      paymentModel.extraAmount + selectedInvoice.totalFinalPrice / 10;
    if (paymentModel.paymentType === 1) {
      paymentModel.cashAmount = paymentAmount;
      paymentModel.amount = paymentAmount;
    }
    if (paymentModel.paymentType === 3) {
      paymentModel.posAmount = paymentAmount;
      paymentModel.amount = paymentAmount;
      paymentModel.cashAmount = 0;
    }
    if (paymentModel.paymentType === 4) {
      paymentModel.amount = paymentAmount;
      paymentModel.cashAmount = 0;
      paymentModel.posAmount = 0;
    }
    if (paymentModel.paymentType === 5) {
      paymentModel.posAmount = paymentAmount - paymentModel.cashAmount;
      paymentModel.amount = paymentModel.posAmount;
    }
  };

  const validPayment = () => {
    var errors = [];
    if (selectedInvoice.id === 0)
      errors.push("برای پرداخت باید سفارش انتخاب کنید.");

    if (paymentModel.paymentType === 0)
      errors.push("نحوه پرداخت باید انتخاب شود.");

    if (paymentModel.amount === 0)
      errors.push("برای پرداخت باید مبلغ پرداخت مقدار داشته باشد.");

    if (
      (paymentModel.paymentType === 3 || paymentModel.paymentType === 5) &&
      paymentModel.posDeviceId < 1
    )
      errors.push("برای پرداخت دستگاه کارتخوان را انتخاب کنید.");

    if (
      (paymentModel.paymentType === 3 || paymentModel.paymentType === 5) &&
      paymentModel.amount < 3000
    )
      errors.push("مبلغ پرداختی پوز نمی تواند کمتر از 3000 تومن باشه.");

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const makePayment = async () => {
    if (!validPayment()) return false;
    if (paymentModel.paymentType !== 3) setLoading(true);
    setpaymentWaiting(true);
    const payResp = await apiMethod.orderPayment({
      paymentType: paymentModel.paymentType,
      posDeviceId: paymentModel.posDeviceId,
      invoiceId: selectedInvoice.id,
      exraAmount: paymentModel.extraAmount * 10,
      amount: paymentModel.amount * 10,
      cashAmount: paymentModel.cashAmount * 10,
      cardNumber: "",
      delivered: paymentModel.delivered,
      isFreePosPayment: paymentModel.isFreePosPayment
    });

    setpaymentWaiting(false);

    if (!methods.showApiErrors(payResp)) return false;

    resetPaymentModel();
    await confirmInvoice();
    setPaymentModalShow(false);
    await getGridData();
    setLoading(false);
  };

  const cancelPayment = async () => {
    const apiRes = await apiMethod.cancelPayment({
      posDeviceId: parseInt(paymentModel.posDeviceId),
      invoiceId: selectedInvoice.id,
    });
    if (!methods.showApiErrors(apiRes)) return false;
    setpaymentWaiting(false);
    methods.showSuccesses(["پرداخت با موفقیت لغو شد."]);
  };

  const confirmInvoice = async () => {
    const apiRes = await apiMethod.confirmOrder(selectedInvoice.id);
    if (!methods.showApiErrors(apiRes)) return false;
  };

  const openPaymentModal = (invoice) => {
    selectedInvoice.id = invoice.id;
    selectedInvoice.totalFinalPrice = invoice.totalFinalPrice;
    setSelectedInvoice({ ...selectedInvoice });
    setPaymentModalShow(true);
  };

  const resetPaymentModel = () => {
    paymentModel.paymentType = 0;
    paymentModel.posDeviceId = 0;
    paymentModel.invoiceId = selectedInvoice.id;
    paymentModel.extraAmount = 0;
    paymentModel.amount = 0;
    paymentModel.cashAmount = 0;
    paymentModel.posAmount = 0;
    paymentModel.cardNumber = "";
    paymentModel.isFreePosPayment = false;

    setPaymentModel({ ...paymentModel });
  };

  const resetFilters = () => {
    filterModel.invoiceNumber = "";
    filterModel.merchantPhone = "";
    filterModel.merchantName = "";
    filterModel.merchantCode = "";
    filterModel.orderNumber = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.endDate = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const URL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveNewOrderPanel", (bid, orderId, status) => {
      if (status === 3) getGridData();
    });
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const selectedItem = gridData.find((item) => item.id === show);

  const renderDeliveryOrderList = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <div className="row bg-light">
            <div
              className={`col-xxl-${
                collapsed ? 1 : 2
              } border-end border-secondary-subtle p-0 bg-white`}
            >
              <div className="d-flex justify-content-end pt-4">
                <span className="toggleImg" onClick={toggleSidebar}>
                  {collapsed ? (
                    <i className="bi bi-arrow-left-circle fs-5"></i>
                  ) : (
                    <i className="bi bi-arrow-right-circle fs-5"></i>
                  )}
                </span>
              </div>
              <div className="d-flex flex-column gap-3 px-4 mt-5">
                <button className="btn btn-purple">سفارش های من</button>
                <Link to="/DeliveryPanel/archive" className="w-100">
                  <button className="btn btn-outline-purple w-100">
                    آرشیو سفارشات
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-xxl-10 mt-3 mx-auto">
              <div className="saleheader">
                <p>سفارش‌های من</p>
              </div>
              <div className="saleheader">
                <div className="text-end bg-dangar pt-1">
                  <span>اسکن سفارش</span>
                  <i className="bi bi-qr-code-scan fs-3 mx-2"></i>
                </div>
                <div className="row g-2">
                  <div className="col-12 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      نام
                    </label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.merchantName}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          merchantName: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      شماره سفارش
                    </label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.orderNumber}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          orderNumber: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      شماره اشتراک
                    </label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.merchantCode}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          merchantCode: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      شماره فاکتور
                    </label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.invoiceNumber}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          invoiceNumber: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2">
                    <label htmlFor="enddate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-2 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="px-3 border border-rounded bg-white">
                <div className="saletable">
                  <div className="row">
                    {gridData?.map((item, index) => (
                      <>
                        <div className="col-12 col-md-6 col-lg-4">
                          <div
                            className="card courier-card mb-3"
                            style={{ height: "95%" }}
                          >
                            <div className="card-body">
                              <div className="row">
                                <div className="col-4 col-xxl-4 d-flex mb-3 fs-14">
                                  <span>
                                    {methods.toPersianDate(
                                      item.createDate,
                                      "jYYYY/jMM/jDD"
                                    )}
                                  </span>
                                </div>
                                <div className="col-4 col-xxl-4 d-flex justify-content-center mb-3 fs-14">
                                  <span style={{ fontWeight: "bold" }}>
                                    {item.merchantName}
                                  </span>
                                </div>
                                <div className="col-4 col-xxl-4 d-flex justify-content-end mb-3 fs-14">
                                  <span className="badge sidebar-badge rounded-pill ms-2">
                                    {
                                      orderTypes.find(
                                        (orderType) =>
                                          orderType.id === item.orderType
                                      )?.title
                                    }
                                  </span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span>اشتراک : {item.merchantCode}</span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span>
                                    شماره فاکتور : {item.invoiceNumber}
                                  </span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span>شماره سفارش : {item.orderNumber}</span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span>موبایل : {item.merchantPhone}</span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span> وضعیت: {item.isPaid ? "پرداخت شده" : "پرداخت نشده"}</span>
                                </div>
                                <div className="col-6 col-xxl-6 d-flex mb-3 fs-14">
                                  <span>نوع : {item.paymentTypeName}</span>
                                </div>
                                <div className="col-6 col-xxl-4 d-flex mb-3 fs-14">
                                  <span>
                                    {methods.toPersianDate(
                                      item.createDate,
                                      " ساعت: HH:mm"
                                    )}
                                  </span>
                                </div>                         
                                <div className="col-12 d-flex mb-3 fs-14">
                                  <span className="text-justify fs-14">
                                    آدرس:{" "}
                                    <span className="break-text">{item.destination}</span>
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-6">
                                  <button
                                    className="btn btn-outline-purple w-100"
                                    style={{ height: "48px" }}
                                    onClick={() => handleShow(item.id)}
                                  >
                                    جزئیات
                                  </button>
                                  <DeliveryPanel
                                    show={show === item.id}
                                    onHide={handleClose}
                                    selectedItem={selectedItem}
                                  />
                                </div>
                                <div className="col-6">
                                  {item.isPaid &&
                                    item.totalFinalPrice - item.totalPayAmount >=
                                    0 ? (
                                    <button
                                      type="button"
                                      style={{ width: "100%" }}
                                      className="btn custome-btn btn-purple !w-full"
                                      onClick={() =>
                                        deliveryToMerchant(item.id)
                                      }
                                    >
                                      تحویل به مشتری
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      style={{ width: "100%" }}
                                      className="btn custome-btn btn-purple w-full"
                                      onClick={() => {
                                        openPaymentModal(item);
                                      }}
                                    >
                                      پرداخت
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </div>
        }
      </>
    );
  };

  const closeModal = () => {
    setPaymentModalShow(false);
    resetPaymentModel();
  };

  const paymentModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: paymentModalShow ? "block" : "none" }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">پرداخت سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  closeModal();
                }}
              ></button>
            </div>
            <div className="modal-body position-relative">
              {paymentWaiting && (
                <div className="payment-waining position-absolute pt-4">
                  <div className="payment-messagebox text-center p-4">
                    <h4>لطفا کار مشتری را در دستگاه کارتخوان بکشید</h4>
                    <p>پس از کشیدن کارت مبلغ نمایش داده می شود.</p>
                    <div className="mt-4">
                      <button
                        onClick={() => {
                          cancelPayment();
                        }}
                        type="button"
                        className="btn btn-outline-light btn-lg"
                      >
                        لغو پرداخت
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mb-4">
                <div className="col-md-3 mb-3">
                  <div className="form-group mb-3">
                    <label className="mb-2">نحوه پرداخت</label>
                    <select
                      value={paymentModel.paymentType}
                      onChange={(e) => {
                        paymentTypeChanged(e.target.value);
                      }}
                      className="form-select form-control"
                    >
                      <option value={0}>انتخاب کنید</option>
                      <option value={3}>کارتخوان</option>
                      <option value={1}>نقدی</option>
                      <option value={4}>کارت به کارت</option>
                      <option value={5}>نقدی و کارتخوان</option>
                    </select>
                  </div>
                </div>
                {(paymentModel.paymentType === 3 ||
                  paymentModel.paymentType === 5) && (
                    <>
                      <div className="col-md-3 mb-3">
                        <div className="mb-3">
                          <label className="mb-2">دستگاه کارتخوان</label>
                          <select
                            value={paymentModel.posDeviceId}
                            onChange={(e) => {
                              setPaymentModel({
                                ...paymentModel,
                                posDeviceId: e.target.value,
                              });
                            }}
                            className="form-select"
                          >
                            <option value={0}>انتخاب دستگاه</option>
                            {posDevices.map((item, index) => (
                              <option value={item.posId} key={index}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>
                  )}
                <div className="col-md-3 mb-3">
                  <div className="mb-3">
                    <label className="mb-2">اضافات (تومن)</label>
                    <input
                      value={methods.addNumSeperator(paymentModel.extraAmount)}
                      onChange={(e) => {
                        extraAmountChanged(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>
                </div>
                {(paymentModel.paymentType === 1 ||
                  paymentModel.paymentType === 5) && (
                    <>
                      <div className="col-md-3 mb-3">
                        <div className="mb-3">
                          <label className="mb-2">نقدی (تومن)</label>
                          <input
                            value={methods.addNumSeperator(
                              paymentModel.cashAmount
                            )}
                            onChange={(e) => {
                              cashAmountChanged(e.target.value);
                            }}
                            type="text"
                            className="form-control"
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </>
                  )}
                {(paymentModel.paymentType === 5 ||
                  paymentModel.paymentType === 3) && (
                    <>
                      <div className="col-md-3 mb-3">
                        <div className="form-group">
                          <label className="mb-2">پوز (تومن)</label>
                          <input
                            value={methods.addNumSeperator(
                              paymentModel.posAmount
                            )}
                            //onChange={(e) => { setPaymentModel({ ...paymentModel, posAmount: e.target.value }) }}
                            type="text"
                            className="form-control"
                            placeholder="0"
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  )}
              </div>
              <div className="mb-4 text-center">
                <button
                  onClick={() => {
                    makePayment();
                  }}
                  type="button"
                  className="btn btn-purple w-25 me-2"
                >
                  پرداخت
                </button>
                {(paymentModel.paymentType === 3 || paymentModel.paymentType === 5) && (
                  <>
                    <button
                      onClick={() => {
                        paymentModel.isFreePosPayment = true;
                        setPaymentModel({ ...paymentModel });
                        makePayment();
                      }}
                      type='button' className='btn btn-outline-purple w-25'>پرداخت آزاد</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isUserLogedin ? (
        <>
          <DeliveryHeader setCollapsed={setCollapsed} />
          {renderDeliveryOrderList()}
          {paymentModalShow && paymentModal()}
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default DeliveryOrderList;
